import type { Vendor } from "../../types/marketplace.types";
import { useConnectWizardStore } from "../../store/connectWizard.store";
import { TermsSignaturePanel } from "../TermsSignaturePanel";

interface WizardStep2TermsProps {
  vendor: Vendor;
}

export function WizardStep2Terms({ vendor }: WizardStep2TermsProps) {
  const termsScrolled = useConnectWizardStore((s) => s.termsScrolled);
  const termsAccepted = useConnectWizardStore((s) => s.termsAccepted);
  const signerName = useConnectWizardStore((s) => s.signerName);
  const markTermsScrolled = useConnectWizardStore((s) => s.markTermsScrolled);
  const setTermsAccepted = useConnectWizardStore((s) => s.setTermsAccepted);
  const setSignerName = useConnectWizardStore((s) => s.setSignerName);

  return (
    <TermsSignaturePanel
      idPrefix="connect"
      vendorName={vendor.name}
      termsMarkdown={vendor.termsMarkdown}
      termsVersion={vendor.termsVersion}
      signerName={signerName}
      termsScrolled={termsScrolled}
      termsAccepted={termsAccepted}
      onScrolled={markTermsScrolled}
      onAcceptedChange={setTermsAccepted}
      onSignerNameChange={setSignerName}
    />
  );
}
